export const AllowanceCodes = [
  { code: 'Allowance', type: 'Allowance', label: 'Additional Reduction' },
  { code: 'Charge', type: 'Charge', label: 'Additional Cost' },
]
